import { TThunkAction } from '../../types/redux';
import { TUser } from '../../types/currentUser';
import { resolveUser } from '../../services/user';
import { prepareUser } from '../../mappers/prepareUser';
import { setStatusSucceed } from './types';

export function getUserAction(): TThunkAction<Promise<TUser | undefined>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, custom } = context;
    const user = await resolveUser({ httpApi, logger, subdomain: custom.subdomain });
    const mappedUser = prepareUser(user);
    dispatch(setStatusSucceed(mappedUser));

    return mappedUser;
  };
}
